var ezdia;
(function (ezdia) {
    var groupChartsWrapper = function (context) {
        var id = context.id;
        var ret = "<div id=\"" + id + "\" class=\"ez-group-chart\" data-chart=\"groupchart\">\n      <div class=\"ez-loading\"><span class=\"text\"><i class=\"fa fa-bar-chart\"></i><br>Loading...</span></div>\n    </div>";
        return ret;
    };
    var gridWrapper = function (context) {
        var tableId = context.tableId, footerId = context.footerId;
        var ret = "<table id=\"" + tableId + "\" style=\"width:auto\">\n      <tr><td></td></tr>\n    </table>\n    <div id=\"" + footerId + "\" style=\"width:auto\"></div>";
        return ret;
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var chartsEmpty = function (context) {
        var ret = "<div class=\"row\" style=\"margin-top: 30px; color: #9B9B9B;\">\n      <div class=\"col-md-12 text-center\">\n        <p>There are no charts to display.</p>\n      </div>\n    </div>";
        return ret;
    };
    var shareItemsLink = function (context) {
        var error = context.error, message = context.message, label = context.label, link = context.link;
        var htmlMarkup = '';
        if (!error) {
            htmlMarkup = "<div class=\"row\">\n        <div id=\"ez-dashboard-share-link-msg\" class=\"bg-success ez-share-link-msg\" style=\"display: none\"></div>\n      </div>\n      <form id=\"ez-dhashboard-share-form\" class=\"ez-dhashboard-share-form form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-md-2 control-label\">Charts</label>\n          <div class=\"form-control-static col-md-10\">" + label + "</div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-2 control-label\">Type</label>\n          <div class=\"col-md-10\">\n            <div class=\"radio\">\n              <label><input type=\"radio\" name=\"ez_dashboard_email_share_type\" value=\"false\" checked> Share full link</label>\n            </div>\n            <div class=\"radio\">\n              <label><input type=\"radio\" name=\"ez_dashboard_email_share_type\" value=\"true\"> Share embed link</label>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-2 control-label\">Url</label>\n          <div class=\"form-control-static col-md-10\"><a id=\"ez-dashboard-share-link-preview\" href=\"" + link + "&embed=false\" target=\"_blank\" class=\"ez-share-link\">" + link + "&embed=false</a></div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-md-2 control-label\">Email</label>\n          <div class=\"col-md-10\">\n              <input type=\"text\" id=\"ez-dashboard-email-input\" name=\"emailLink\" class=\"form-control\" placeholder=\"Enter email\">\n              <p class=\"help-block small\">Enter the email address of the person to whom you would like to share the dashboard.</p>\n          </div>\n        </div>\n      </form>";
        }
        var ret = "<div class=\"ez-dashboard-share-item-view\">\n      " + (error
            ? "<div class=\"row\">\n        <div class=\"col-md-12\">\n          <div class=\"ez-error\">" + message + "</div>\n        </div>\n       </div>"
            : '') + " " + htmlMarkup + "\n    </div>";
        return ret;
    };
    var chartsTaskList = function (context) {
        var e_1, _a;
        var error = context.error;
        var list = '';
        if (!error) {
            try {
                for (var _b = __values(Object.entries(context)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], valueArray = _d[1];
                    if (key !== 'global') {
                        list = "<div class=\"task-list-group-name\">" + key + "</div>";
                    }
                    list = "" + valueArray
                        .map(function (items) {
                        var titleLink = items.title_link, title = items.title, count = items.count, dueDate = items.due_date, description = items.description;
                        return "<div class=\"item\">\n            <p class=\"title\">\n                <i class=\"fa fa-check\"></i>\n                <span class=\"main-title\">" + (titleLink ? "<a href=\"" + titleLink + "\">" + title + "</a>" : "" + title) + "</span>\n                " + (count
                            ? "<span class=\"sub-title\">" + count + " " + (count < 2 ? 'Item' : 'Items') + "</span>"
                            : '') + "\n                " + (dueDate ? "<span class=\"sub-title\">" + dueDate + "</span>" : '') + "\n            </p>\n            <p class=\"description\">" + description + "</p>\n          </div>";
                    })
                        .join('');
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var ret = "<div class=\"ez-dashboard-task-list\">\n      " + (error ? "<i class=\"fa fa-tasks\"></i> No data to display" : "" + list) + "\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.dashboard = {
            groupChartsWrapper: groupChartsWrapper,
            gridWrapper: gridWrapper,
            chartsEmpty: chartsEmpty,
            chartsTaskList: chartsTaskList,
            shareItemsLink: shareItemsLink
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
